/* global axios */
import ApiClient from "dashboard/api/ApiClient";

class WahaApi extends ApiClient {
	constructor() {
		super("waha/inboxes", { accountScoped: true });
	}

	create(payload) {
		return axios.post(this.url, payload);
	}

	sessionStatus(inboxId) {
		return axios.get(`${this.url}/${inboxId}/session_status`);
	}

	start(inboxId) {
		return axios.post(`${this.url}/${inboxId}/start`);
	}

	stop(inboxId) {
		return axios.post(`${this.url}/${inboxId}/stop`);
	}

	restart(inboxId) {
		return axios.post(`${this.url}/${inboxId}/restart`);
	}

	reconnect(inboxId) {
		return axios.post(`${this.url}/${inboxId}/reconnect`);
	}

	qr(inboxId) {
		// Prefer WAHA-rendered PNG so the phone scans the engine QR, not a third-party re-encode.
		return axios.get(`${this.url}/${inboxId}/qr`, { params: { format: "image" } });
	}

	requestCode(inboxId, phone) {
		return axios.post(`${this.url}/${inboxId}/request_code`, { phone });
	}

	updateApp(inboxId, payload) {
		return axios.patch(`${this.url}/${inboxId}/app`, payload);
	}
}

export default new WahaApi();
